import { http } from '@/lib/http'

export default class WeatherWarningRepository {
  async get(code: string) {
    const response = await http.get(`/weather-warning/${code}`)

    return response.data
  }
}
